import { render } from "./NumberSetting.vue?vue&type=template&id=223c41ee&scoped=true"
import script from "./NumberSetting.vue?vue&type=script&lang=ts"
export * from "./NumberSetting.vue?vue&type=script&lang=ts"

import "./NumberSetting.vue?vue&type=style&index=0&id=223c41ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-223c41ee"

export default script